import { Injectable } from '@nestjs/common';
import { HolidaysCalendarDTO } from './holidays-calendar.dto';
import { HolidaysCalendar } from '../holidays-calendar.entity';


@Injectable()
export class HolidaysCalendarAdapter {
  
  public convertDtoToEntity(holidaysCaleDTO: HolidaysCalendarDTO,  isUpdate: boolean = false ): HolidaysCalendar {
    const holidayCalendar = new HolidaysCalendar();
    holidayCalendar.holidayId=holidaysCaleDTO.holidayId;
    holidayCalendar.holidayName=holidaysCaleDTO.holidayName;
    holidayCalendar.holidayDate=holidaysCaleDTO.holidayDate;
    // holidayCalendar.holidayYear=holidaysCaleDTO.holidayYear;
    // company.isActive = statesDto.isActive == undefined ? true : statesDto.isActive;
    holidayCalendar.isActive=holidaysCaleDTO.isActive==undefined?true:holidaysCaleDTO.isActive;
    if (isUpdate) {
        holidayCalendar.updatedUser = holidaysCaleDTO.updatedUser;
    } else {
        holidayCalendar.isActive = true;
        holidayCalendar.createdUser = holidaysCaleDTO.createdUser;
    }
   return holidayCalendar;
  }
  public convertEntityToDto(holidayCalendarObject: HolidaysCalendar): HolidaysCalendarDTO {
    const holidayCalendarDto= new HolidaysCalendarDTO;
    holidayCalendarDto.holidayId=holidayCalendarObject.holidayId;
    holidayCalendarDto.holidayName=holidayCalendarObject.holidayName;
    holidayCalendarDto.holidayDate=holidayCalendarObject.holidayDate;
    //holidayCalendarDto.holidayYear=holidayCalendarObject.holidayYear;
    holidayCalendarDto.isActive = holidayCalendarObject.isActive;
    holidayCalendarDto.createdAt = holidayCalendarObject.createdAt;
    holidayCalendarDto.updatedAt = holidayCalendarObject.updatedAt;
    holidayCalendarDto.createdUser = holidayCalendarObject.createdUser;
    holidayCalendarDto.updatedUser = holidayCalendarObject.updatedUser;
    holidayCalendarDto.versionFlag = holidayCalendarObject.versionFlag;
    return holidayCalendarDto;
  }
}